{
  "title": "如何建立帳號並完成 Email 驗證",
  "description": "使用 Email 與密碼註冊帳號，並透過驗證信完成 Email 驗證以啟用帳號。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您會有一組可登入的帳號，且已完成 Email 驗證，可以開始加入或建立隊伍。",
  "roleNote": "任何尚未有帳號的使用者",
  "prerequisites": ["可收信的 Email 信箱", "設定一組至少 10 碼的密碼"],
  "pathLabel": "註冊帳號",
  "steps": [
    {
      "title": "1. 填寫註冊表單",
      "description": "輸入 Email、密碼（至少 10 碼）、顯示名稱，並通過機器人驗證（Turnstile）後送出。"
    },
    {
      "title": "2. 查看畫面提示",
      "description": "送出後畫面一律顯示相同的「請查看您的信箱」訊息，無論該 Email 是否已被註冊過，這是刻意設計，避免被用來探測哪些 Email 已註冊。"
    },
    {
      "title": "3. 收取驗證信並點擊連結",
      "description": "檢查收件匣（含垃圾郵件），點擊信中的驗證連結；連結效期為 24 小時。"
    },
    {
      "title": "4. 驗證完成並自動登入",
      "description": "點擊連結後系統會建立帳號、標記 Email 已驗證，並自動為您建立登入 session，直接導向平台首頁，不需要再手動登入一次。"
    }
  ],
  "afterward": ["帳號已建立，Email 已驗證，且已自動登入", "可以開始查詢競賽、加入或建立隊伍"],
  "nextSteps": "接下來請見「如何建立或加入隊伍」開始參加競賽。",
  "faq": [
    {
      "q": "驗證信一直沒收到怎麼辦？",
      "a": "請確認垃圾郵件匣；若仍未收到，可用同一個 Email 重新送出一次註冊表單，系統會重新寄送一封新的驗證信（新連結會取代舊連結，舊連結失效）。"
    },
    {
      "q": "驗證連結過期或已被使用會怎樣？",
      "a": "系統會提示連結無效或已過期；請用同一個 Email 重新註冊一次以取得新的驗證信。"
    },
    {
      "q": "我用某個 Email 送出註冊表單，畫面卻沒有明確說『這個信箱已經註冊過』，這是正常的嗎？",
      "a": "是正常的。無論該 Email 是否已被註冊，畫面一律顯示相同的成功訊息，這是為了避免帳號列舉（enumeration）攻擊；若該信箱已註冊過，直接使用登入頁面即可，不需要重新設定密碼。"
    }
  ]
}
